module.exports = __webpack_public_path__ + "media/images/pic/products/tluszcz-twardy-7bc389ce8ba1988b1e9257003b6fe0dc.jpg";